export default __webpack_public_path__ + "static/media/right-menu-bars.fc2aca56.svg";